<template>
  <div id="small_tips">
    <el-dialog
      :title="tipsData.title"
      :visible.sync="tipsVisible"
      width="430"
      :before-close="() => { $emit('tipsSwitch', false, tipsType) }"
    >
      <div class="body_content">
        <svg-icon :icon-class="tipsData.svgClass" />
        <div class="text_bpx" :style="`margin-left:${textMargin}px;width:${textWidth}px`">
          {{ tipsData.text }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="close_btn" @click="() => { $emit('tipsSwitch', false, tipsType) }">取 消</el-button>
        <el-button class="confirm_btn" type="primary" @click="() => { $emit('tipsSwitch', true, tipsType) }">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tipsVisible: {
      type: [Boolean]
    },
    tipsData: {
      type: [Object],
      default: () => {}
    },
    // 用于判断弹窗类型，看个人需求传参
    tipsType: {
      type: [Number],
      default: null
    },
    textWidth: {
      type: [Number, String],
      default: 290
    },
    textMargin: {
      type: [Number, String],
      default: 11
    }
  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
#small_tips {
    .body_content {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 150px;
        border-bottom: 1px solid #C4CBD7;
        .svg-icon {
            width: 61px;
            height: 61px;
        }
        .text_bpx {
            width: 280px;
            margin-left: 11px;
            font-size: 24px;
            color: #676871;
        }
    }
    .dialog-footer {
        .close_btn {
            border: 1px solid #C4CBD7;
            color: #C4CBD7;
        }
    }
}
</style>
<style lang="scss">
#small_tips {
    .el-dialog {
        position: relative;
        top: 45% !important;
        width: 429px;
        height: 252px;
        border-radius: 10px;
    }
    .el-dialog__header {
        height: 40px;
        font-size: 16px;
        padding-left: 23px;
        border-radius: 10px 10px 0 0;
    }
    .el-dialog__body {
        padding: 0;
    }
    .dialog-footer {
        .el-button {
            width: 80px;
            height: 36px;
        }
    }
}
</style>
